import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/auth");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setAuth(data);
        navigate(data.membership ? "/dashboard" : "/onboarding", { replace: true });
      } catch (e) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/auth"), 2000);
      }
    })();
  }, [navigate, setAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <p className="text-muted-foreground text-sm">{error || "Signing you in…"}</p>
    </div>
  );
}
